import { render, staticRenderFns } from "./FloatingInner.vue?vue&type=template&id=5ff25fa6&lang=pug&"
var script = {}
import style0 from "./FloatingInner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports